import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, ShieldCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";

export function PrivacyGate() {
  const [info, setInfo] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { api.get("/rgpd").then((r) => setInfo(r.data)).catch(() => {}); }, []);
  const ack = async () => {
    setBusy(true);
    try { await api.post("/rgpd/ack"); setInfo({ ...info, acknowledged: true }); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const open = !!info && !info.acknowledged;
  return (
    <Dialog open={open}>
      <DialogContent className="max-w-xl [&>button]:hidden" onEscapeKeyDown={(e) => e.preventDefault()} onPointerDownOutside={(e) => e.preventDefault()} data-testid="privacy-gate">
        <div className="flex items-center gap-2"><ShieldCheck className="h-5 w-5 text-emerald-600" /><DialogTitle className="font-display">Vos données personnelles</DialogTitle></div>
        <DialogDescription className="text-xs">{info?.controller} · contact : {info?.dpo_email}</DialogDescription>
        <div className="text-sm text-slate-700 whitespace-pre-line max-h-[50vh] overflow-auto leading-relaxed">{info?.notice_text}</div>
        <div><Button className="w-full" onClick={ack} disabled={busy} data-testid="privacy-ack-btn">{busy && <Loader2 className="h-4 w-4 animate-spin mr-2" />}J'ai pris connaissance de cette information</Button></div>
      </DialogContent>
    </Dialog>
  );
}
